import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// A file dropped anywhere outside a FilePicker must do nothing. The browser's
// default is to navigate away and open that PDF, which silently throws away a
// half-filled form.
const swallowStrayDrop = (e) => {
  if (Array.from((e.dataTransfer && e.dataTransfer.types) || []).includes("Files")) e.preventDefault();
};
window.addEventListener("dragover", swallowStrayDrop);
window.addEventListener("drop", swallowStrayDrop);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
